import { useWSQuery, WSQueryConfig } from "@ws-react-query";
import { TaxEstimate, TaxEstimateRequest } from "@wingspanhq/wingspan-api-sdk";
import { taxEstimatesApi } from "@api";
import { WSServiceError } from "../../utils/serviceHelper";

export const QUERY_V3_TAX_ESTIMATE = "QUERY_V3_TAX_ESTIMATE";

const createTaxEstimate = (year: number) => {
  const taxEstimateRequest: TaxEstimateRequest = { year };

  return taxEstimatesApi.createTaxEstimate({ taxEstimateRequest });
};

/**
 * The tax estimate for a year. `createTaxEstimate` is a POST that computes and
 * returns the estimate without persisting anything, so it is consumed as a read
 * (hand-written rather than off the `queries*` registry, which routes every
 * non-`get`/`list`/`search` method to `useMutation`).
 *
 * The request is `{ year }` alone: the filing status, state and expected income
 * it computes with are the ones stored on the tax profile, written through
 * `PATCH /v3/finance/tax-withholdings/settings`. A changed answer therefore
 * reaches the estimate by being saved and this query invalidated
 * (`QUERY_V3_TAX_ESTIMATE`), never by being passed in.
 *
 * `retry: false` because a member with no tax profile yet gets a deterministic
 * failure — retrying only delays the caller's fallback.
 */
export const useQueryTaxEstimate = (
  year: number,
  config?: WSQueryConfig<TaxEstimate, WSServiceError>
) =>
  useWSQuery<TaxEstimate, WSServiceError>(
    [QUERY_V3_TAX_ESTIMATE, year],
    () => createTaxEstimate(year),
    { retry: false, ...config }
  );
